import React from 'react';
import InfoText from '../atoms/InfoText';
import { format } from 'date-fns';
import { ar, enUS } from 'date-fns/locale';
import { Skeleton } from 'antd';
import CardWrapper from './CardWrapper';
import Action from './Action';
import { useTranslation } from 'react-i18next';

export interface LogDetailItem {
  label: string;
  value: React.ReactNode;
}

export interface LogDetailsCardProps {
  items?: LogDetailItem[];
  functionType: string;
  placement: string;
  date: string;
  action: { name: string; code: string };
  isLoading: boolean;
}

export const LogDetailsCard: React.FC<LogDetailsCardProps> = ({
  functionType,
  date,
  placement,
  action,
  isLoading = false,
}) => {
  const { t, i18n } = useTranslation();
  const currentLocale = i18n.language === 'ar' ? ar : enUS;

  const items = [
    { label: t('configLogs.action'), value: <Action action={action} /> },
    { label: t('configLogs.functionType'), value: functionType },
    { label: t('configLogs.placement'), value: placement },
    {
      label: t('configLogs.date'),
      value: date ? format(date, 'dd MMM yyyy', { locale: currentLocale }) : '-',
    },
    {
      label: t('configLogs.time'),
      value: date ? format(date, 'hh:mm a', { locale: currentLocale }) : '-',
    },
  ];

  return (
    <CardWrapper title={t('configLogs.details')}>
      <div className="divide-y divide-light-input-border mt-2">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between py-4 first:pt-0 last:pb-0"
          >
            <InfoText
              text={item.label}
              className="text-sm font-medium text-light-text-primary"
            />

            {isLoading ? (
              <Skeleton.Input
                active
                size="small"
                style={{ width: 100, height: 20 }}
              />
            ) : (
              item?.value && (
                <InfoText
                  text={item?.value as string}
                  className="text-sm font-bold text-light-text-primary"
                />
              )
            )}
          </div>
        ))}
      </div>
    </CardWrapper>
  );
};

export default LogDetailsCard;
